const MONTHS = [
  '', 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',
]

const MONTHS_LOWER = [
  'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
  'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre',
]

export const QUINZAINE_OPTIONS = [
  { value: 1, label: '1ère quinzaine (1 → 15 du mois)' },
  { value: 2, label: '2ème quinzaine (16 → fin du mois)' },
]

export const getQuinzaineLabel = (quinzaine) => {
  if (quinzaine === 1) return '1ère quinzaine'
  if (quinzaine === 2) return '2ème quinzaine'
  return '—'
}

export const getSuggestedCampaignSlot = (date = new Date()) => {
  const day = date.getDate()
  let month = date.getMonth() + 1
  let year = date.getFullYear()
  let quinzaine

  if (day >= 1 && day <= 15) {
    quinzaine = 2
    month -= 1
    if (month < 1) {
      month = 12
      year -= 1
    }
  } else {
    quinzaine = 1
  }

  return { month, year, quinzaine }
}

export const formatCampaignFullLabel = (month, year, quinzaine = 1) =>
  `${MONTHS[month] || month} ${year} — ${getQuinzaineLabel(quinzaine)}`

export const describeCampaignQuinzaine = (month, year, quinzaine) => {
  const monthName = MONTHS[month] || month
  if (quinzaine === 1) {
    return `Factures du 1er au 15 ${monthName} ${year} — envoi habituel entre le 16 et la fin du mois`
  }
  return `Factures du 16 au dernier jour ${monthName} ${year} — envoi habituel entre le 1er et le 15 du mois suivant`
}

export const getEmailPreviewForToday = (date = new Date()) => {
  const slot = getSuggestedCampaignSlot(date)
  const qText = slot.quinzaine === 1 ? '1ère' : '2ème'
  const monthName = MONTHS_LOWER[slot.month - 1]
  return `Si vous envoyez aujourd'hui, le mail indiquera : « …${qText} quinzaine du mois de ${monthName}… »`
}

export const isCampaignSlotMatchingSendWindow = (month, year, quinzaine, date = new Date()) => {
  const suggested = getSuggestedCampaignSlot(date)
  return suggested.month === month && suggested.year === year && suggested.quinzaine === quinzaine
}

export const formatCampaignDisplayLabel = (campaign) => {
  if (!campaign) return '—'
  const q = campaign.quinzaine || 1
  const full = formatCampaignFullLabel(campaign.month, campaign.year, q)
  if (!campaign.label || /^Corporate\s+/i.test(campaign.label)) return full
  return campaign.label
}

export const getQuinzaineBadgeClass = (quinzaine) =>
  quinzaine === 2 ? 'quinzaineBadgeQ2' : 'quinzaineBadgeQ1'

export const getInvoiceRangeShort = (quinzaine) =>
  quinzaine === 1 ? '1 → 15 du mois' : '16 → fin du mois'

export const getSendWindowShort = (quinzaine) =>
  quinzaine === 1
    ? 'Envoi : 16 → fin du mois'
    : 'Envoi : 1 → 15 du mois suivant'
